export default __webpack_public_path__ + "static/media/a5m.068f20d1.png";